import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { getAssetDimensions, getAssetUrl, } from '../../../utils/contentfulHelpers';
const ImageSvg = lazy(() => import('./svg'));
const ContentfulImage = (props) => {
    var _a, _b;
    const { asset, alt, width, height, style, loading, sizes, srcSet, objectFit, className, } = props;
    const imageUrl = getAssetUrl(asset);
    const dimensions = getAssetDimensions(asset);
    const contentType = asset.fields.file.contentType;
    if (!imageUrl) {
        return null;
    }
    const imageAlt = alt || ((_a = asset.fields) === null || _a === void 0 ? void 0 : _a.title) || ((_b = asset.fields) === null || _b === void 0 ? void 0 : _b.description) || '';
    const imageWidth = width || (dimensions === null || dimensions === void 0 ? void 0 : dimensions.width);
    const imageHeight = height || (dimensions === null || dimensions === void 0 ? void 0 : dimensions.height);
    if (contentType === 'image/svg+xml') {
        return (_jsx(Suspense, { fallback: null, children: _jsx(ImageSvg, Object.assign({}, props)) }));
    }
    if (contentType.includes('video'))
        return (_jsx("video", { src: imageUrl, autoPlay: true, muted: true, loop: true, preload: "auto", role: "img", "aria-label": imageAlt }));
    return (_jsx("img", { src: imageUrl, alt: imageAlt, width: imageWidth, height: imageHeight, className: className, style: Object.assign(Object.assign({}, style), { objectFit }), loading: loading, sizes: sizes, srcSet: srcSet }));
};
export default ContentfulImage;
